import { Core } from "@/core/Core";

export default {

  /* Items */

  async getItems(context, {inventoryId, augment = 'backend'}) {
    try {
      return await Core.request("GET", `/api/inventory/${inventoryId}/items`, {augment, admin: true});
    } catch (e) {
      return null;
    }
  },

  async getItem(context, {inventoryId, itemId, version, augment = 'backend'}) {
    try {
      return await Core.request("GET", `/api/inventory/${inventoryId}/items/${itemId}`, {augment, version});
    } catch (e) {
      return null;
    }
  },

  async saveItem(context, {inventoryId, itemId, data, version}) {
    try {
      let query = version ? `?version=${version}` : '';
      return await Core.request("PUT", `/api/inventory/${inventoryId}/items/${itemId}${query}`, data);
    } catch (e) {
      return null;
    }
  },

  async createItem(context, {inventoryId, data, version}) {
    try {
      let query = version ? `?version=${version}` : '';
      return await Core.request("POST", `/api/inventory/${inventoryId}/items${query}`, data);
    } catch (e) {
      return null;
    }
  },

  async cloneItem(context, {inventoryId, itemId}) {
    try {
      return await Core.request("POST", "/api/inventory/" + inventoryId + "/items", { cloneFrom: itemId });
    } catch (e) {
      return null;
    }
  },

  async deleteItem(context, {inventoryId, itemId}) {
    try {
      return await Core.request("DELETE", "/api/inventory/" + inventoryId + "/items/" + itemId);
    } catch (e) {
      return null;
    }
  },

  async saveItemsPriorities(context, {inventoryId, data}) {
    try{
      return await Core.request("POST", "/api/inventory/" + inventoryId + "/items/update-priority", data);
    } catch (e) {
      return null;
    }
  },

  async getItemUsage(context, {inventory, id, type}) {
    let url = "/api/inventory/" + inventory;
    switch(type) {
      case "category":
        url += "/categories/" + id + "/usages";
        break;
      case "modifier-group":
        url += "/modifier_groups/" + id + "/usages";
        break;
      case "choice":
        url += "/choices/" + id + "/usages";
        break;
      case "choice-item":
      case "modifier":
      case "item":
      default:
        url += "/orderables/" + id + "/usages";
        break;
    }
    try {
      return await Core.request("GET", url);
    } catch (e) {
      return new Core.Error(e);
    }
  }
}